import InsuranceInYourHands from './InsuranceInYourHands';

export default InsuranceInYourHands;
